import './index.css'

const LanguageButton = props => {
  const {btnDetails, isActive, updateLanguageBtn} = props
  const {id, buttonText} = btnDetails
  const onBtnClick = () => {
    updateLanguageBtn(id)
  }
  const activeBtnClassName = isActive ? 'active-btn' : ''
  return (
    <li className="btn-item">
      <button
        type="button"
        onClick={onBtnClick}
        className={`normal-btn ${activeBtnClassName}`}
      >
        {buttonText}
      </button>
    </li>
  )
}

export default LanguageButton
